import type { OptionType, PopupSelectProps } from '@atlaskit/select';

type CustomPopperModifiers<Modifiers extends string> = NonNullable<
	NonNullable<PopupSelectProps<OptionType, boolean, Modifiers>['popperProps']>['modifiers']
>;

export type CustomPopperModifier<Modifiers extends string = string> =
	CustomPopperModifiers<Modifiers>[number];

export const isPositiveNumber = (value: unknown): value is number => {
	return typeof value === 'number' && value > 0;
};

export const matchReferenceWidthModifier: CustomPopperModifier = {
	name: 'matchReferenceWidth',
	enabled: true,
	phase: 'beforeWrite',
	fn: ({ state }) => {
		if (isPositiveNumber(state?.rects?.reference?.width)) {
			state.styles.popper.width = `${state.rects.reference.width}px`;
		}
	},
};
